module.exports = __webpack_public_path__ + "static/media/51fda6e2.jpg";